import format from 'date-fns/format'
import isWeekend from 'date-fns/is_weekend'
import endOfWeek from 'date-fns/end_of_week'
import subDays from 'date-fns/sub_days'
import isAfter from 'date-fns/is_after'
import differenceInDays from 'date-fns/difference_in_days'

export default {

  getWeekDate () {
    const date = new Date()
    // const date = new Date()
    return format(isWeekend(date)
      ? subDays(endOfWeek(date, { weekStartsOn: 1 }), 2)
      : date, 'YYYY-MM-DD')
  },

  format (date) {
    // date YYYY-MM-DD
    return date
      ? format(date, 'M[月]').padStart(3) + format(date, 'D[日]').padStart(3)
      : '-'
  },

  isAfter (date, dateToCompare) {
    return isAfter(date, dateToCompare)
  },

  isOverdue (date) {
    return date ? isAfter(new Date(), date) : false
  },

  dueSoon (date) {
    return date ? (!this.isOverdue(date) && (differenceInDays(date, new Date()) < 3)) : false
  },

  getWeekDay (forward = true) {
    const date = new Date()
    if (date.getDay() === 6) {
      date.setDate(date.getDate() - 1)
    } else if (date.getDay() === 0) {
      const step = forward ? 1 : -2
      date.setDate(date.getDate() + step)
    }
    return date.getDay() - 1
  }
}




// WEBPACK FOOTER //
// ./src/modules/dateUtils.js